import PostsPage from "@/pages/PostsPage";
import RequestEditDetails from "@/pages/RequestEditDetails";
import RequestEdits from "@/pages/RequestEdits";
import SingleRequestDetail from "@/pages/SingleRequestDetail";
import { lazy } from "react";
import { BsBriefcaseFill, BsFillGrid3X3GapFill } from "react-icons/bs";
import { FaEdit } from "react-icons/fa";
import {
  FaBox,
  FaBoxOpen,
  FaHouseChimneyCrack,
  FaNewspaper,
} from "react-icons/fa6";
import { FiLogIn } from "react-icons/fi";
import { IoMdPerson } from "react-icons/io";
import { RiSettings4Fill, RiSettings5Fill } from "react-icons/ri";

const Login = lazy(() => import("../pages/Login"));
const Users = lazy(() => import("../pages/Users"));
const UserDetails = lazy(() => import("../pages/Users/UserDetails"));
const ForgotPassword = lazy(() => import("../pages/ForgotPassword"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const ProfileSettings = lazy(() => import("../pages/ProfileSettings"));
const ProductName = lazy(() => import("../pages/Crud/Products"));
const Plants = lazy(() => import("../pages/Crud/Plants"));
const Subscriptions = lazy(() => import("../pages/Subscriptions"));
const SystemSettings = lazy(() => import("../pages/SystemSettings"));
const Notifications = lazy(() => import("../pages/Notifications"));
const Deals = lazy(() => import("../pages/Deals"));
const DealDetail = lazy(() => import("../pages/Deals/DealDetail"));
export const routes = [
  {
    path: "/login",
    exact: true,
    protected: false,
    showInSidebar: false,
    title: "Login",
    element: <Login />,
    icon: <FiLogIn />,
  },
  {
    path: "/forgot-password",
    exact: true,
    protected: false,
    showInSidebar: false,
    title: "Forgot Password",
    element: <ForgotPassword />,
    icon: <FiLogIn />,
  },
  // Dashboard
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    element: <Dashboard />,
    icon: <BsFillGrid3X3GapFill />,
  },
  {
    path: "/users",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Users",
    element: <Users />,
    icon: <IoMdPerson />,
  },
  {
    path: "/users/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Details",
    element: <UserDetails />,
  },
  {
    path: "/subscriptions",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Subscriptions",
    element: <Subscriptions />,
    icon: <FaBoxOpen />,
  },

  {
    path: "/products",
    exact: true,
    protected: true,
    icon: <FaBox />,
    showInSidebar: true,
    title: "Products",
    element: <ProductName />,
  },

  {
    path: "/plants",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Plants",
    icon: <FaHouseChimneyCrack />,
    element: <Plants />,
  },
  {
    path: "/posts",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Posts",
    icon: <FaNewspaper />,
    element: <PostsPage />,
  },
  {
    path: "/deals",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Deals",
    icon: <BsBriefcaseFill />,
    element: <Deals />,
  },
  {
    path: "/deals/trade/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Listing Details",
    element: <DealDetail kind="trade" />,
  },
  {
    path: "/deals/work/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Listing Details",
    element: <DealDetail kind="work" />,
  },
  {
    path: "/settings",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Settings",

    icon: <RiSettings4Fill />,
    element: <ProfileSettings />,
  },
  {
    path: "/request-edits",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Request Edits",
    icon: <FaEdit />,
    element: <RequestEdits />,
  },
  {
    path: "/request-edits/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Request Edit Details",
    element: <RequestEditDetails />,
  },
  {
    path: "/system-settings",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "System Settings",
    icon: <RiSettings5Fill />,
    element: <SystemSettings />,
  },
  {
    path: "/request-edits/:postId/:requestEditId",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Request Edit Details",
    element: <SingleRequestDetail />,
  },
  {
    path: "/notifications",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Notifications",
    element: <Notifications />,
  },
];
